import { Source, Layer } from "react-map-gl";
import { getListOfLevels } from "../util/ColorHelper";

export const painter = (json, geojsonPolygones) => {
  if (json.strategy === "interpolate") {
    return genericInterpolate(json, geojsonPolygones);
  } else if (json.strategy === "step") {
    return genericStep(json);
  } else {
    console.log("Unknown strategy " + json.strategy);
  }
};

// TODO LATER : Add automaic tests for this function
const genericInterpolate = (json, geojson) => {
  const { legendLevels, limits } = getListOfLevels(json, geojson);
  // The limits are roughly the min and max values of the property (around 10% and 80%), like {min: 100, max: 800}
  const interpolation = ["interpolate", ["linear"], ["get", json.propertyName]];

  if (json.colorForZero && limits.smallestNonzeroValue > 0) {
    interpolation.push(0, json.colorForZero); // Define color when property==0 because they are not interesting
    // for statistics. However if the property domain contains negative numbers we should still always consider zero
    // among normal values.
  }
  interpolation.push(limits.smallestNonzeroValue, json.colorList[0]);
  // Typically, property==1, and normally differ from value for property==0

  for (let i = 0; i < legendLevels.length; i++) {
    interpolation.push(legendLevels[i].level);
    interpolation.push(legendLevels[i].color);
    // Linear interpolation of colors will apply between these levels.
  }

  const returnValue = {
    "fill-color": interpolation,
    "fill-opacity": [
      "step",
      ["get", json.propertyName],
      json.opacities.zero, // Define opacity for property ==0
      1,
      json.opacities.nonZero, // Define opacity for property >=1
    ],
  };
  return returnValue;
};

const genericStep = (json) => {
  const step = ["step", ["get", json.propertyName]];
  if (json.keyValues.length + 1 !== json.colorList.length) {
    throw new Error("The number of keyValues should be one less than the number of colors");
  }
  json.keyValues.forEach((keyValue, index) => {
    step.push(json.colorList[index]); // The first color is used for all values <= the first key value
    step.push(keyValue);
  });
  step.push(json.colorList[json.colorList.length - 1]); // The last color is used for all values above the last key value
  const returnValue = {
    "fill-color": step,
    "fill-opacity": [
      "step",
      ["get", json.propertyName],
      json.opacities.zero, // Define opacity for field ==0
      1,
      json.opacities.nonZero, // Define opacity for field >=1
    ],
  };
  return returnValue;
};

const getFillLayer = (layerId, sourceId, json, geojsonPolygones) => {
  const retValue = {
    id: layerId,
    type: "fill",
    source: sourceId,
    paint: painter(json, geojsonPolygones),
    minzoom: json.minzoom,
    maxzoom: json.maxzoom,
    beforeId: "waterway-label",
  };

  return retValue;
};

export const fillLayer = (layerId, sourceId, json, geojsonPolygones) => (
  <>
    <Source id={sourceId} type="geojson" data={geojsonPolygones}>
      <Layer {...getFillLayer(layerId, sourceId, json, geojsonPolygones)} />
    </Source>
  </>
);

const getTextLayer = (layerId, sourceId, json, geojsonPolygones) => {
  const retValue = {
    id: layerId,
    type: "symbol",
    source: sourceId,
    layout: {
      "text-field": ["to-string", ["get", json.propertyName]],
      "text-anchor": "center",
      "text-justify": "center",
      "text-size": 12,
    },
    paint: { "text-color": json.textColor },
    minzoom: json.minzoom,
    maxzoom: json.maxzoom,
  };
  return retValue;
};

export const printNoContrattiAtPoint = (layerId, sourceId, json, geojsonPointsWithNumbers) => (
  <>
    <Source id={sourceId} type="geojson" data={geojsonPointsWithNumbers}>
      <Layer {...getTextLayer(layerId, sourceId, json, geojsonPointsWithNumbers)}></Layer>
    </Source>
  </>
);
